module.exports = __webpack_public_path__ + "static/img/下载 (1).3b654fc4.png";